/* Move the original introduction; native details state and listeners stay intact. */
(() => {
  if (window.ypcIntroPlacementInstalled) return;
  window.ypcIntroPlacementInstalled = true;
  const twoColumns = window.matchMedia('(min-width: 750px)');
  const anchors = new WeakMap();

  function place(root) {
    const intro = root.querySelector('[data-ys-product-description].ys-intro-faq');
    const gallery = root.querySelector('[data-ys-gallery]');
    const media = gallery?.closest('.product__media-wrapper');
    if (!intro || !media) return;
    let home = anchors.get(intro);
    if (!home) {
      home = document.createComment('Yoga Space introduction mobile position');
      intro.before(home);
      anchors.set(intro, home);
    }
    const destination = twoColumns.matches ? media : home.parentNode;
    const next = twoColumns.matches ? gallery.nextSibling : home.nextSibling;
    if (!destination || next === intro) return;
    const focused = intro.contains(document.activeElement) ? document.activeElement : null;
    if (typeof destination.moveBefore === 'function') destination.moveBefore(intro, next);
    else destination.insertBefore(intro, next);
    if (focused && document.activeElement !== focused) focused.focus({ preventScroll: true });
  }

  function update() {
    document.querySelectorAll('.yogaspace-product-main').forEach(place);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
  twoColumns.addEventListener('change', update);
  document.addEventListener('shopify:section:load', update);
})();
